document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.question-item')) {
        const questionItems = document.querySelectorAll('.question-item');

        questionItems.forEach((question) => {
            question.addEventListener('click', function() {
                if(question.classList.contains('active')) {
                    question.classList.remove('active')
                } else {
                    question.classList.add('active');
                }
            })
        })
    }
});
